
<div class="mx-3 mx-lg-0">
  <div class="card my-5 col-xl-9 col-xxl-8 mx-auto rounded-4 overflow-hidden p-4">
  <div class="row g-4">
          <div class="col-lg-6 d-flex">
            <div class="card-body">
              <div class="form-body mt-4">
                <form class="row g-3"[formGroup]="loginForm"(ngSubmit)="loginForm.valid && onLogin()"novalidate>
                  <div class="col-12">
                    <label for="inputEmailAddress" class="form-label">Email</label>
                    <input type="email" id="inputEmail" class="form-control"formControlName="email" placeholder="Login" required autofocus>
                  </div>
                  <div class="col-12">
                    <label for="inputChoosePassword" class="form-label">Password</label>
                    <div class="input-group" id="show_hide_password">
                      <input [type]="fieldTextType ? 'text' : 'password'" id="inputPassword" class="form-control"formControlName="password" placeholder="Mot de passe" required
                        placeholder="Enter Password">
                      <a  class="input-group-text bg-transparent"> <i
                        class="fa"
                        [ngClass]="{
                          'fa-eye-slash': !fieldTextType,
                          'fa-eye': fieldTextType
                        }"
                        (click)="toggleFieldTextType()"
                      ></i></a>
                    </div>
                  </div>
                  <!-- Conditional Dropdown for User Type -->
        <div *ngIf="userTypes.length > 1; else singleUserType" style="display: flex; justify-content: center; margin-top: 25px;">
          <select formControlName="userType" style="width: 100%; padding: 10px; border-radius: 5px; border: 1px solid #ccc;">
            <option value="" disabled selected>Choisir un type d'utilisateur</option>
            <option *ngFor="let userType of userTypes" [value]="userType.value">{{ userType.label }}</option>
          </select>
        </div>

        <!-- Auto-Assign User Type for Single Value -->
        <ng-template #singleUserType>
          <input type="hidden" formControlName="userType">
        </ng-template>

        <div *ngIf="loginForm.get('userType')?.invalid && loginForm.get('userType')?.touched" style="color: red; padding-left: 20px;">
          Veuillez sélectionner un type d'utilisateur pour se connecter.
        </div>
                  <div class="col-md-6">
                    <div class="form-check form-switch">
                      <input class="form-check-input" type="checkbox" id="flexSwitchCheckChecked" checked>
                      <label class="form-check-label" for="flexSwitchCheckChecked">Remember Me</label>
                    </div>
                  </div>
                  <div class="col-md-6 text-end"> <a href="auth-boxed-forgot-password.html">Forgot Password ?</a>
                  </div>
                  <div class="col-12">
                    <div class="d-grid">
                      <button  type="submit" value="Login" (click)="onLogin()" [disabled]="loginForm.invalid">Login</button>
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="text-start">
                      <p class="mb-0">Don't have an account yet? <a routerLink="/auth/signup" routerLinkActive="active">Sign up here</a>
                      </p>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <div class="col-lg-6 d-lg-flex d-none">
            <div class="p-3 rounded-4 w-100 d-flex align-items-center justify-content-center bg-grd-primary">
              <img src="assets/images/auth/login1.png" class="img-fluid" alt="">
            </div>
          </div>
    
        </div><!--end row-->
      </div>
    
    </div>